(function () {
  function initSwatchSwap() {
    document.querySelectorAll('[data-product-card]').forEach(function (card) {
      if (card.dataset.swatchSwapInit) return;
      card.dataset.swatchSwapInit = 'true';

      card.querySelectorAll('.color-swatch__item[data-image-url]').forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();

          var imgUrl        = swatch.getAttribute('data-image-url');
          var secondImgUrl  = swatch.getAttribute('data-second-image-url');
          var productUrl    = swatch.getAttribute('data-product-url');
          var productHandle = productUrl ? productUrl.split('/products/').pop().split('?')[0] : null;

          // 1. Swap l'image principale
          var img = card.querySelector('[data-card-image]');
          if (img && imgUrl) {
            img.src    = imgUrl;
            img.srcset = imgUrl;
          }

          // 2. Swap la deuxième image (hover) — image[1] du produit enfant
          var secondImg = card.querySelector('.product-card__image--second img');
          if (secondImg && secondImgUrl) {
            secondImg.src    = secondImgUrl;
            secondImg.srcset = secondImgUrl;
          }

          // 3. Mettre à jour tous les liens de la carte (full-width link + titre)
          card.querySelectorAll('.product-card__link, .product-card__title a').forEach(function (link) {
            link.href = productUrl;
          });

          // 4. Mettre à jour le handle sur tous les boutons quick view / quick add
          if (productHandle) {
            card.querySelectorAll('[data-product-quickview]').forEach(function (btn) {
              btn.setAttribute('data-product-quickview', productHandle);
            });
          }

          // 5. Marquer la pastille active
          card.querySelectorAll('.color-swatch__item').forEach(function (s) {
            s.classList.remove('is-active');
          });
          swatch.classList.add('is-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchSwap);
  } else {
    initSwatchSwap();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) initSwatchSwap();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
